import { useRouter } from 'expo-router';

/**
 * Safely wraps `useRouter` from `expo-router`.
 *
 * Returns `null` when called outside an `expo-router` context.
 */
export const useSafeRouter = () => {
  try {
    return useRouter();
  } catch {
    return null;
  }
};
